export default __webpack_public_path__ + "static/media/ql_background.d69fdff5.png";